import {
  UPLOAD_SYLLABUS_REQUEST,
  UPLOAD_SYLLABUS_SUCCESS,
  UPLOAD_SYLLABUS_FAILURE,
  CREATE_DRAFT_SYLLABUS_REQUEST,
  CREATE_DRAFT_SYLLABUS_SUCCESS,
  CREATE_DRAFT_SYLLABUS_FAILURE,
  GET_SYLLABUS_REQUEST,
  GET_SYLLABUS_SUCCESS,
  GET_SYLLABUS_FAILURE,
  UPDATE_SYLLABUS_SETTINGS_REQUEST,
  UPDATE_SYLLABUS_SETTINGS_SUCCESS,
  UPDATE_SYLLABUS_SETTINGS_FAILURE,
  UPDATE_SYLLABUS_STATUS_REQUEST,
  UPDATE_SYLLABUS_STATUS_SUCCESS,
  UPDATE_SYLLABUS_STATUS_FAILURE,
  UPDATE_SYLLABUS_ROW_STATUS,
  UPDATE_SYLLABUS_READING_STATUS,
} from '../actions/syllabus';

const initialState = {
  loading: false,
  error: null,
  currentSyllabus: null,
  uploadedRows: [],
};

export default function syllabusReducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_SYLLABUS_REQUEST:
    case CREATE_DRAFT_SYLLABUS_REQUEST:
    case GET_SYLLABUS_REQUEST:
    case UPDATE_SYLLABUS_SETTINGS_REQUEST:
    case UPDATE_SYLLABUS_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPLOAD_SYLLABUS_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadedRows: action.payload.rows || [],
      };

    case CREATE_DRAFT_SYLLABUS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentSyllabus: action.payload,
      };

    case GET_SYLLABUS_SUCCESS:
    case UPDATE_SYLLABUS_SETTINGS_SUCCESS:
    case UPDATE_SYLLABUS_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentSyllabus: action.payload,
      };

    case UPDATE_SYLLABUS_ROW_STATUS: {
      const { rowId, status } = action.payload || {};
      const currentRows = state.currentSyllabus?.syllabus?.rows;

      if (!Array.isArray(currentRows)) {
        return state;
      }

      const updatedRows = currentRows.map((row) =>
        row && row._id === rowId ? { ...row, status } : row,
      );

      return {
        ...state,
        currentSyllabus: {
          ...state.currentSyllabus,
          syllabus: {
            ...(state.currentSyllabus?.syllabus || {}),
            rows: updatedRows,
          },
        },
      };
    }

    case UPDATE_SYLLABUS_READING_STATUS: {
      const { rowId, readingId, status } = action.payload || {};
      const currentRows = state.currentSyllabus?.syllabus?.rows;

      if (!Array.isArray(currentRows)) {
        return state;
      }

      const updatedRows = currentRows.map((row) => {
        if (!row || row._id !== rowId || !Array.isArray(row.readings)) {
          return row;
        }

        return {
          ...row,
          readings: row.readings.map((reading) =>
            reading && reading._id === readingId
              ? { ...reading, status }
              : reading,
          ),
        };
      });

      return {
        ...state,
        currentSyllabus: {
          ...state.currentSyllabus,
          syllabus: {
            ...(state.currentSyllabus?.syllabus || {}),
            rows: updatedRows,
          },
        },
      };
    }

    case UPLOAD_SYLLABUS_FAILURE:
    case CREATE_DRAFT_SYLLABUS_FAILURE:
    case GET_SYLLABUS_FAILURE:
    case UPDATE_SYLLABUS_SETTINGS_FAILURE:
    case UPDATE_SYLLABUS_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
